import { styled } from "@mui/material/styles";
import { Box, Card as MuiCard, Button, TableCell } from "@mui/material";
import {
  TABLE_BODY_ROW_HEIGHT,
  TABLE_COMPACT_HEADER_HEIGHT,
  TABLE_COMPACT_HEADER_PADDING,
  TABLE_HEADER_FONT_SIZE,
} from "../Table/constants.js";

const jakartaRootSx = {
  fontFamily: '"Plus Jakarta Sans", sans-serif',
  "& .MuiTypography-root, & .MuiButton-root, & .MuiInputBase-root, & .MuiInputLabel-root, & .MuiMenuItem-root, & .MuiTableCell-root, & .MuiChip-label, & .MuiFormLabel-root, & .MuiSelect-select":
    {
      fontFamily: '"Plus Jakarta Sans", sans-serif',
    },
  "& .MuiTableBody-root .MuiTableRow-root.MuiTableRow-hover:hover": {
    backgroundColor: "#ECF1F7",
  },
};

export const PageRoot = styled(Box)(({ theme }) => ({
  ...jakartaRootSx,
  width: "100%",
  minHeight: "100vh",
  padding: theme.spacing(4),
  background: "transparent",
  backgroundColor: "transparent",
}));

export const MainCard__body = styled(Box)(({ theme }) => ({
  ...jakartaRootSx,
  display: "flex",
  flexDirection: "column",
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  borderRadius: "12px",
  backgroundColor: "transparent",
}));

export const TitleWrap = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(0.5),
}));

export const Card = styled(MuiCard)(({ theme }) => ({
  ...jakartaRootSx,
  borderRadius: "12px",
  padding: "20px",
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  boxShadow: theme.shadows[2],
  background: "transparent",
  backgroundColor: "transparent",
}));

export const Toolbar = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.spacing(2),
  padding: theme.spacing(2, 0),
}));

export const SearchBox = styled(Box)(({ theme }) => ({
  flex: 1,
  maxWidth: 380,
}));

export const FiltersWrap = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
}));

export const FiltersButton = styled(Button)(({ theme }) => ({
  textTransform: "none",
  borderRadius: 10,
  padding: theme.spacing(1, 2),
  fontWeight: 600,
  background: theme.palette.grey[100],
  color: theme.palette.text.primary,
  "&:hover": {
    background: theme.palette.grey[200],
  },
}));

export const HeaderCell = styled(TableCell)(({ theme }) => ({
  fontFamily: '"Plus Jakarta Sans", sans-serif',
  fontWeight: 700,
  fontSize: TABLE_HEADER_FONT_SIZE,
  color: "rgba(0,0,0,0.70)",
  backgroundColor: "#F9F9F9",
  borderBottom: 0,
  height: TABLE_COMPACT_HEADER_HEIGHT,
  padding: TABLE_COMPACT_HEADER_PADDING,
  lineHeight: "18px",
  whiteSpace: "nowrap",
}));

export const BodyCell = styled(TableCell)(({ theme }) => ({
  fontFamily: '"Plus Jakarta Sans", sans-serif',
  fontSize: "0.85rem",
  height: TABLE_BODY_ROW_HEIGHT,
  padding: 0,
  boxSizing: "border-box",
  borderBottom: "1px solid #f5f5f5",
  whiteSpace: "nowrap",
}));

export const Footer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  marginTop: theme.spacing(1),
}));

export const TotalText = styled(Box)(({ theme }) => ({
  fontSize: "0.85rem",
  fontWeight: 600,
  color: theme.palette.text.secondary,
}));
